import React from "react";
import { Grid } from "@mui/material";
import Logical from "./Logical";
import reportbuilder from "./ReportBuilder.module.css";
import DropValues from "./Values/DropValues";
import DropDimensionsTable from "./Dimensions/DropDimensionsTable";
import { ButtonStyles } from "../DashBoardLayout/styles/ButtonStyles";
const SelectedItems = (props) => {
  return (
    <Grid
      xs={12}
      className="drop selectBoxRB"
      sx={{
        height: "32vh",
        display: "flex",
        gap: "1vh",
        flexDirection: "row",
        backgroundColor: "#fff",
      }}
    >
      <Grid className="valueBoxRB" xs={12} md={3} sx={{margin:"0.5rem 0rem 0rem 1rem"}}
      >
        <p>Selected Dimensions</p>
        <Grid
          className="dimDropTable"
          sx={{ height: "26vh", overflowX: "hidden"}}
        >
          <DropDimensionsTable /> {/* here */}
        </Grid>
      </Grid>
      {/* <Grid md={0.02}>
        <hr
          className={reportbuilder.line}
          style={{
            height: "11.5rem",
            color: "rgb(158, 154, 154)",
            opacity: "0.4",
            // margin:"0.6rem 0",
            border: "0.1px solid rgb(158, 154, 154)",
            background: "grey",
          }}
        ></hr>
      </Grid> */}
      <hr
        className={reportbuilder.line}
        style={{
          height: "28vh",
          color: "rgb(158, 154, 154)",
          opacity: "0.4",
          margin: "auto",
          background: "grey",
        }}
      ></hr>
      <Grid xs={12} md={3} sx={{margin:"0.5rem 0rem 0rem 0.5rem"}}>
        <p style={{ marginLeft: "0rem" }} className={reportbuilder.header1}>
          Selected Values
        </p>
        <Grid className="valDropTable" sx={{ height: "26vh", overflowX: "hidden" }}>
          <DropValues />
        </Grid>
      </Grid>
      <hr
        className={reportbuilder.line}
        style={{
          height: "28vh",
          color: "rgb(158, 154, 154)",
          opacity: "0.4",
          margin: "auto",
          background: "grey",
        }}
      ></hr>
      <Grid xs={12} md={7} sx={{margin:"0.5rem 0rem 0rem 0.5rem", width:"98%"}}>
          <p> Logical f(x) </p>
          <Logical />
      </Grid>
    </Grid>
  );
};

export default SelectedItems;
